/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ===========================================================================
   SlingCenter — collection card price sync            2026-09-30, PRD task #82
   ===========================================================================

   THE BUG
   The inline handler at the bottom of snippets/product-item.liquid does exactly
   one thing when a card's variant dropdown changes:

       var primary = priceEl.querySelector('.price--highlight, .price');
       if (primary) { primary.textContent = formatted; }

   It updates the PRICE and nothing else. The struck-through compare-at price
   and the savings badge keep the FIRST variant's values. On the Large Animal
   Sling the first variant is the Yearling/Foal, so selecting the Large showed
   price $4,000, struck-through $4,000 and "Save $1,000" — three numbers, none
   of which agreed with each other.

   It also replaced the element's textContent outright, destroying the child
   <span class="visually-hidden">Sale price</span>, so screen readers lost the
   label after the first variant change.

   WHY THE FIX LIVES HERE AND NOT IN THE TEMPLATE
   The <option> elements carry only price, not compare-at. Adding attributes
   would mean rewriting a 350-line Liquid file to change three lines. Instead
   this reads the real variant data from Shopify's own /products/<handle>.js,
   keyed off the product link already present in every card, cached per handle.
   custom.js is loaded site-wide, so no template is touched at all.

   It listens on the same 'change' event and registers later than the inline
   handler, so it runs second: it corrects the price write and fills in the two
   fields the original never touched.

   Applies to every multi-variant card on the site, not just the animal sling.
   =========================================================================== */
(function () {
  if (window.__scCardPriceSync) { return; }
  window.__scCardPriceSync = true;

  var cache = {};

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  // Write price text without destroying the visually-hidden label.
  function setPriceText(el, txt) {
    if (!el.querySelector('.visually-hidden')) { el.textContent = txt; return; }
    var n = el.lastChild;
    while (n && n.nodeType !== 3) { n = n.previousSibling; }
    if (n) { n.nodeValue = ' ' + txt; return; }
    el.appendChild(document.createTextNode(' ' + txt));
  }

  function handleFor(card) {
    var a = card.querySelector('a.product-item__title, a.product-item__image-wrapper, a[href*="/products/"]');
    if (!a) { return null; }
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function apply(card, variant) {
    var priceEl = card.querySelector('.price-list, .product-item__price-list');
    if (!priceEl) { return; }

    var price  = variant.price;
    var cmp    = variant.compare_at_price || 0;
    var onSale = cmp > price;

    // 1. the price itself
    var primary = priceEl.querySelector('.price--highlight, .price');
    if (primary) {
      setPriceText(primary, money(price));
      primary.classList.toggle('price--highlight', onSale);
    }

    // 2. the struck-through compare-at
    var compareEl = priceEl.querySelector('.price--compare');
    if (compareEl) {
      if (onSale) {
        setPriceText(compareEl, money(cmp));
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // 3. the savings badge
    var badge = card.querySelector('.product-label--on-sale');
    if (onSale) {
      if (!badge) {
        var list = card.querySelector('.product-item__label-list');
        if (list) {
          badge = document.createElement('span');
          badge.className = 'product-label product-label--on-sale';
          badge.appendChild(document.createTextNode('Save '));
          badge.appendChild(document.createElement('span'));
          list.appendChild(badge);
        }
      }
      if (badge) {
        var inner = badge.querySelector('span');
        if (inner) { inner.textContent = money(cmp - price); }
        else { badge.textContent = 'Save ' + money(cmp - price); }
        badge.style.display = '';
      }
    } else if (badge) {
      badge.style.display = 'none';
    }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select.sc-inline-variant');
    if (!sel) { return; }

    var card = sel.closest('.product-item') || sel.closest('article') || sel.closest('div.grid__cell');
    if (!card) { return; }

    var wantId = parseInt(sel.value, 10);
    if (!wantId) { return; }

    var handle = handleFor(card);
    if (!handle) { return; }

    function use(data) {
      if (!data || !data.variants) { return; }
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === wantId) { apply(card, data.variants[i]); return; }
      }
    }

    if (cache[handle]) { use(cache[handle]); return; }

    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) { cache[handle] = d; use(d); } })
      .catch(function () { /* leave the original handler's price in place */ });
  });
})();